<template>
  <div>
    <transition name="modal">
      <confirmation-modal
        v-if="showRefundConfirmationModal"
        :message="'¿Estás seguro que deseas reembolsar este pago?'"
        @close="showRefundConfirmationModal = false"
        @confirm="refundPayment"
      ></confirmation-modal>
    </transition>

    <div class="card-bordered w-full sm:w-72 h-fit">
      <p class="font-medium">#{{ orderInvoice.id }}</p>
      <p class="text-sm font-medium">
        {{ integerToCurrency(orderInvoice.total) }}
      </p>
      <p class="text-xs text-content-400">
        {{ formatDatetime(orderInvoice.created_at) }}
      </p>
      <p v-if="orderInvoice.type" class="text-xs text-content-500 mt-1">
        {{ orderInvoice.type }}
      </p>
      <p v-if="orderInvoice.payment_method_brand && orderInvoice.payment_method_last4" class="text-xs text-content-500 mt-1">
        {{ capitalizeFirstLetter(orderInvoice.payment_method_brand) }} **** {{ orderInvoice.payment_method_last4 }}
      </p>
      <p v-if="orderInvoice.refunded" class="text-sm font-medium mt-2 text-error-500">
        {{ integerToCurrency(orderInvoice.refunded) }} Reembolsados
      </p>

      <div v-if="showRefundForm" class="flex flex-col mt-2">
        <p class="font-medium text-sm">Cantidad a reembolsar</p>

        <input
          id="shipping_option"
          type="number"
          step="any"
          v-model="refundAmount"
          class="w-full"
        />

        <button
          class="cancel-button mt-2"
          @click.prevent="showRefundForm = false"
        >
          Cancelar
        </button>

        <primary-button
          class="mx-0 mt-2"
          :loading="loadingRefundUpdate"
          type="submit"
          @click.prevent="showRefundConfirmationModal = true"
          >Reembolsar</primary-button
        >
      </div>
      <div v-else>
        <button
          v-if="!showRefundForm && canRefund && orderInvoice.refunded < orderInvoice.total"
          class="secondary-button block mt-2"
          @click.prevent="showRefundForm = true"
        >
          Reembolsar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from "../ui/ConfirmationModal";
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Payment",

  components: {
    ConfirmationModal,
  },

  data() {
    return {
      showRefundForm: false,
      refundAmount: null,
      showRefundConfirmationModal: false,
      loadingRefundUpdate: false,
    };
  },

  props: {
    orderInvoice: Object,
    canRefund: Boolean,
  },

  created() {
    this.refundAmount = this.orderInvoice.total - this.orderInvoice.refunded;
  },

  methods: {
    formatDatetime,
    integerToCurrency,

    capitalizeFirstLetter: function(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    async refundPayment() {
      this.showRefundConfirmationModal = false;
      this.confirmShippingPriceUpdate = false;
      this.loadingRefundUpdate = true;

      try {
        const response = await api.quotes.refundPayment(this.orderInvoice.id, {
          refund_amount: this.refundAmount,
        });
        this.$store.dispatch("successSnack", response.message);
        this.$emit("refunded");
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingRefundUpdate = false;
    },
  },
};
</script>